import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { toast, ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import {
  getStallPossession_action,
  insertStallPossession_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stall_possession_action/stall_possession_action";
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import { toastError, toastSuccess, BASE_URL } from "../../../../../utils/constants";
import { data } from "jquery";
import moment from "moment";
import DatePicker from "react-datepicker";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import ImageCapture from "../../../../../utils/ImageCapture";
import VendorDetails from "../../vendorDetails";

class StallPossesion extends Component {
  // Initialize Component
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      exhCompanyName: "",
      hallNo: "",
      stallNo: "",
      personName: "",
      companyName: "",
      stallPossessionId: "",
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      countryId: "",
      contactNo: "",
      email: "",
      isAgree: false,
      remark: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      // Err Msg
      personNameErr: "",
      companyNameErr: "",
      contactNoErr: "",
      emailErr: "",
      StatusID: "",
      DD_DetailsData: [],
      is_View: true,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isImageModal: false,
      NonEmpanelVendorID: null,
      exitPersonName: "",
      exitCompanyName: "",
      exitContactNo: "",
      exitEmail: "",
      exitPersonNameErr: "",
      exitCompanyNameErr: "",
      exitContactNoErr: "",
      exitEmailErr: "",
      NonEmpanelVendorData: {},
      SameAsAbove: false,
    };
    this.getStallPossession = this.getStallPossession.bind(this);
    this.preventMinus = this.preventMinus.bind(this);
    this.handlePaste = this.handlePaste.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.onSubmit()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }
  // On Component Load
  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    this.getStallPossession();
  }

  // Get Stall Possession
  getStallPossession() {
    this.setState({ isLoading: true });
    this.props
      .getStallPossession_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            exhCompanyName: data.data[0][0]["Exhibitor Compnay Name"] || "",
            hallNo: data.data[0][0]["HallNo"] || "",
            stallNo: data.data[0][0]["StallNo"] || "",
            stallPossessionId: data.data[0][0]["StallPossessionID"] || "",
            countryId: data.data[0][0]["CountryID"] || "",
            personName: data.data[0][0]["PersonName"] || "",
            companyName: data.data[0][0]["CompanyName"] || "",
            contactNo: data.data[0][0]["ContactNo"] || "",
            email: data.data[0][0]["Email"] || "",
            isAgree: data.data[0][0]["IS_Agree"] || false,
            remark: data.data[0][0]["Remark"] || "",
            NonEmpanelVendorID: data.data[0][0]["NonEmpanelVendorID"] || "",
            isLoading: false,
            exitPersonName: data.data[0][0]["ExitPersonName"] || "",
            exitCompanyName: data.data[0][0]["ExitCompanyName"] || "",
            exitContactNo: data.data[0][0]["ExitMobileNo"] || "",
            exitEmail: data.data[0][0]["ExitEmailID"] || "",
            NonEmpanelVendorData: data.data[2]?.[0] || {},
          });

          const vendorArray = data.data[0]?.filter(item => item.NonEmpanelVendorID).map((vendor) => {
            // If DD details exist, match them to the vendor (if any)
            const ddInfo = data.data?.[0][0] || [];
            const subContractorList = data.data?.[1].filter(item => item.VendorID == vendor.NonEmpanelVendorID);
            return {
              VendorID: vendor.NonEmpanelVendorID || "",

              // DD details
              DD_Number: vendor.DD_Number || "",
              DD_Amount: vendor.DD_Amount || "",
              DD_Date: vendor.DD_Date ? moment(vendor.DD_Date, "YYYY-MM-DD").toDate() : null,
              DD_BankName: vendor.BankName || "",

              DD_NumberErr: "",
              DD_AmountErr: "",
              DD_DateErr: null,
              DD_BankNameErr: "",

              // DD Submit details
              DD_SubmitPersonName: vendor.DDSubmittedByPersonName || vendor.VendorName || "",
              DD_SubmitCompanyName:
                vendor.DDSubmittedByCompanyName || vendor.VendorCompanyName || "",
              DD_SubmitMobileNo: vendor.DDSubmittedByMobileNo || vendor.VendorMobile || "",
              DD_SubmitEmailId: vendor.DDSubmittedByEmaiID || vendor.VendorEmail || "",

              DD_SubmitPersonNameErr: "",
              DD_SubmitCompanyNameErr: "",
              DD_SubmitMobileNoErr: "",
              DD_SubmitEmailIdErr: "",

              // DD Return details
              DD_ReturnPersonName: vendor.DDReturnToPersonName || "",
              DD_ReturnCompanyName: vendor.DDReturnToCompanyName || "",
              DD_ReturnMobileNo: vendor.DDReturnToMobileNo || "",
              DD_ReturnEmailId: vendor.DDReturnToEmaiID || "",

              DD_ReturnPersonNameErr: "",
              DD_ReturnCompanyNameErr: "",
              DD_ReturnMobileNoErr: "",
              DD_ReturnEmailIdErr: "",

              FileName: vendor.DDReturnToPhotoID
                ? vendor.DDReturnToPhotoID.split('/').pop()
                : null,
              FilePath: vendor.DDReturnToPhotoID || null,
              FileType: null,
              FileNameErr: "",

              SameAsAbove: vendor.IsSameAsAbove || false,
              ServiceName: vendor.ServiceName,
              subContractorList: subContractorList.map((item) => ({
                VendorID: item.VendorID,
                CompanyName: item.SubContractorCompanyName,
                PersonName: item.SubContractorPersonName,
                MobileNo: item.SubContractorMobileNo,
                EmailId: item.SubcontractorEmailID,
              })),
            };
          });

          console.log("vendorArray------------>", vendorArray);
          this.setState({ DD_DetailsData: vendorArray });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleInput = async (e, type, field, parentIndex, childIndex = null) => {
    const updatedList = structuredClone(this.state.DD_DetailsData); // deep clone
    let Value;

    // Determine the input value
    if (type === "date") {
      Value = e.target?.value || e; // handle both cases
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    const errorField = `${field}Err`;

    if (childIndex !== null) {
      // --- Subcontractor level update ---
      updatedList[parentIndex].subContractorList[childIndex][field] = Value;

      if (
        updatedList[parentIndex].subContractorList[childIndex][errorField] !== undefined &&
        Value !== ""
      ) {
        updatedList[parentIndex].subContractorList[childIndex][errorField] = "";
      }
    } else {
      // --- Parent-level update ---
      updatedList[parentIndex][field] = Value;

      const vendor = updatedList[parentIndex];
      // Apply "SameAsAbove" only when toggled on
      if (field === "SameAsAbove") {
        if (Value) {
          vendor.DD_ReturnPersonName = vendor.DD_SubmitPersonName;
          vendor.DD_ReturnCompanyName = vendor.DD_SubmitCompanyName;
          vendor.DD_ReturnMobileNo = vendor.DD_SubmitMobileNo;
          vendor.DD_ReturnEmailId = vendor.DD_SubmitEmailId;
        } else {
          vendor.DD_ReturnPersonName = "";
          vendor.DD_ReturnCompanyName = "";
          vendor.DD_ReturnMobileNo = "";
          vendor.DD_ReturnEmailId = "";
        }
        vendor.DD_ReturnPersonNameErr = "";
        vendor.DD_ReturnCompanyNameErr = "";
        vendor.DD_ReturnMobileNoErr = "";
        vendor.DD_ReturnEmailIdErr = "";
      }

      if (field === "Document") {
        const fileData = await this.onFilePick(e, Value);
        vendor.FileName = fileData.FileName;
        vendor.FilePath = fileData.FilePath;
        vendor.FileType = fileData.FileType;
        vendor.FileNameErr = "";
      }

      if (updatedList[parentIndex][errorField] !== undefined && Value !== "") {
        updatedList[parentIndex][errorField] = "";
      }
    }

    // Always update state after modification
    this.setState({ DD_DetailsData: updatedList }, () => {
      console.log("vendorArray------------>", updatedList);
    });
  };

  preventMinus = (e) => {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text/plain");
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ""); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand("insertText", false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  };

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength);
    }
  };

  // On Back Click
  onCancelClick() {
    window.history.back();
  }

  // Input Validate
  async inputValidate() {
    const {
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      personName,
      companyName,
      contactNo,
      email,
    } = this.state;
    if (exitPersonName == "") {
      this.setState({ exitPersonNameErr: "Please Enter Person Name" });
    }
    if (exitCompanyName == "") {
      this.setState({ exitCompanyNameErr: "Please Enter Company Name" });
    }
    if (exitContactNo == "") {
      this.setState({ exitContactNoErr: "Please Enter Contact No." });
    }
    if (exitEmail == "") {
      this.setState({ exitEmailErr: "Please enter Email" });
    }
    if (personName == "") {
      this.setState({ personNameErr: "Please Enter Person Name" });
    }
    if (companyName == "") {
      this.setState({ companyNameErr: "Please Enter Company Name" });
    }
    if (contactNo == "") {
      this.setState({ contactNoErr: "Please Enter Contact No." });
    }
    if (email == "") {
      this.setState({ emailErr: "Please enter Email" });
    }
    if (contactNo != "") {
      const mobileError = mobileNoValidator(contactNo);
      if (mobileError) {
        this.setState({ contactNoErr: mobileError });
        return mobileError;
      }
    }
    if (email != "") {
      const emailError = emailValidator(email);
      if (emailError) {
        this.setState({ emailErr: emailError });
        return emailError;
      }
    }
    if (exitContactNo != "") {
      const mobileError = mobileNoValidator(exitContactNo);
      if (mobileError) {
        this.setState({ exitContactNoErr: mobileError });
        return mobileError;
      }
    }
    if (exitEmail != "") {
      const emailError = emailValidator(exitEmail);
      if (emailError) {
        this.setState({ exitEmailErr: emailError });
        return emailError;
      }
    }
    return;
  }

  checkDuplicates(array, keys) {
    const seen = new Set();
    const duplicates = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const compositeKey = keys.map((k) => obj[k]).join("|");

      if (seen.has(compositeKey)) {
        duplicates.push({ index: i, values: compositeKey });
      } else {
        seen.add(compositeKey);
      }
    }

    if (duplicates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // On Submit
  async onSubmit() {
    const {
      DD_DetailsData,
      NonEmpanelVendorID,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
    } = this.state;
    console.log("DD_DetailsData--->", DD_DetailsData)
    const valid = await this.inputValidate();
    if (valid) {
      return toastError(valid);
    }
    const validation = this.inputValidateForDDDetails();

    const array1 = [];
    const array2 = [];
    DD_DetailsData.forEach((item) => {
      array1.push({
        VendorID: item.VendorID || null,
        DD_Number: item.DD_Number || null,
        DD_Date: item.DD_Date ? moment(item.DD_Date).format("YYYY-MM-DD") : null,
        DD_Amount: item.DD_Amount || null,
        BankName: item.DD_BankName || null,
        DDSubmittedByCompanyName: item.DD_SubmitCompanyName || null,
        DDSubmittedByPersonName: item.DD_SubmitPersonName || null,
        DDSubmittedByEmaiID: item.DD_SubmitEmailId || null,
        DDSubmittedByMobileNo: item.DD_SubmitMobileNo || null,
        IsSameAsAbove: item.SameAsAbove || false,
        DDReturnByCompanyName: item.DD_ReturnCompanyName || null,
        DDReturnByPersonName: item.DD_ReturnPersonName || null,
        DDReturnByEmaiID: item.DD_ReturnEmailId || null,
        DDReturnByMobileNo: item.DD_ReturnMobileNo || null,
        DDReturnToCompanyName: item.DD_ReturnToCompanyName || null,
        DDReturnToPersonName: item.DD_ReturnToPersonName || null,
        DDReturnToEmaiID: item.DD_ReturnToEmaiID || null,
        DDReturnToMobileNo: item.DDReturnByMobileNo || null,
        FileName: item.FileName || null,
        FileType: item.FileType || null,
        FilePath: item.FilePath || null,
      });

      item.subContractorList.forEach((data) => {
        array2.push({
          VendorID: item.VendorID || null,
          SubcontractorCompanyName: data.CompanyName || null,
          SubcontractorPersonName: data.PersonName || null,
          SubcontractorEmailID: data.EmailId || null,
          SubcontractorMobileNo: data.MobileNo || null,
        });
      });
    });

    const {
      personName,
      companyName,
      contactNo,
      email,
      personNameErr,
      companyNameErr,
      contactNoErr,
      emailErr,
      isAgree,
      remark,
      exitPersonNameErr,
      exitCompanyNameErr,
      exitContactNoErr,
      exitEmailErr,
    } = this.state;
    if (
      exitPersonName != "" &&
      exitCompanyName != "" &&
      exitContactNo != "" &&
      exitEmail != "" &&
      personName != "" &&
      companyName != "" &&
      contactNo != "" &&
      email != "" &&
      (NonEmpanelVendorID ? validation : true)
    ) {
      if (
        exitPersonNameErr == "" &&
        exitCompanyNameErr == "" &&
        exitContactNoErr == "" &&
        exitEmailErr == "" &&
        personNameErr == "" &&
        companyNameErr == "" &&
        contactNoErr == "" &&
        emailErr == ""
      ) {
        if (isAgree) {
          this.setState({ isLoading: true });
          const ManualFormsID = this.props.location.state?.ManualFormsID || null;
          const ServiceID = this.props.location.state?.ServiceID || null;
          const VendorDetails = this.props.location.state?.VendorDetails || {};
          this.props
            .insertStallPossession_action(
              sessionStorage.getItem("ExhRegistrationIDSS"),
              personName,
              companyName,
              contactNo,
              email,
              isAgree,
              remark,
              0,
              array1,
              array2,
              ManualFormsID,
              ServiceID,
              VendorDetails,
              exitPersonName,
              exitCompanyName,
              exitContactNo,
              exitEmail
            )
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false });

                toastSuccess(
                  this.state.StatusID == 0
                    ? "Stall Possession Submitted Successfully"
                    : "Stall Possession Updated Successfully"
                );
                setTimeout(() => {
                  this.props.navigate("/manualForms");
                }, 2000);
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toastError("Please Agree T & C");
        }
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault();
    console.log("file--->", file);
    const { childList, allowedFileTypes } = this.state;
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      // Clear the file input field
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = ""; // Clear the input value
      }

      return;
    } else {
      var image = "";
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        image = await this.convertToBase64(file[0]);

        return {
          FilePath: image,
          FileName: file[0]["name"],
          FileType: file[0]["name"].split(".")[1],
        };
      } else {
        toast.error(`Allowed File types .jpg,.jpeg,.png,.pdf with maximum size 5 MB`, {
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        // Clear the file input field
        document.getElementById("inputGroupFile").value = "";

        return;
      }
    }
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  handleViewFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      // Open viewable files directly
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.document.title = fileName; // Set the tab title to the file name
      }
    } else {
      // Download non-viewable files
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedList = [...prevState.DD_DetailsData];
      updatedList[index] = {
        ...updatedList[index],
        FileName: null,
        FileType: null,
        FilePath: null,
      };
      return { DD_DetailsData: updatedList };
    });
  };

  handleOpenModal = (index) => {
    this.setState({ isImageModal: true, VendorIndex: index });
  };

  handleCloseModal = () => {
    this.setState({ isImageModal: false });
  };

  handleCapture = (imageData) => {
    const { VendorIndex } = this.state;
    this.setState((prevState) => {
      const updatedList = [...prevState.DD_DetailsData];
      updatedList[VendorIndex] = {
        ...updatedList[VendorIndex],
        FileName: "Document",
        FileType: "jpeg",
        FilePath: imageData,
        FileNameErr: "",
      };
      return { DD_DetailsData: updatedList };
    });
    this.setState({ isImageModal: false });
  };

  handleDelete = (parentIndex, childIndex) => {
    const updatedList = [...this.state.DD_DetailsData];
    updatedList[parentIndex].subContractorList = updatedList[parentIndex].subContractorList.filter(
      (_, i) => i !== childIndex
    );
    this.setState({ DD_DetailsData: updatedList });
  };

  inputValidateForDDDetails = () => {
    const { DD_DetailsData } = this.state;
    let isAllValid = true;

    // helper to clear old errors
    const clearErrors = (vendor) => {
      const cleaned = { ...vendor };
      Object.keys(cleaned).forEach((key) => {
        if (key.endsWith("Err")) cleaned[key] = "";
      });
      return cleaned;
    };

    const updatedList = DD_DetailsData.map((item) => {
      let vendor = clearErrors(item);
      let isValid = true;
      let errors = {};

      const mandatoryFields = [
        { key: "DD_Number", label: "DD Number" },
        { key: "DD_Amount", label: "DD Amount" },
        { key: "DD_Date", label: "DD Date", isDate: true },
        { key: "DD_BankName", label: "Bank Name" },
        { key: "DD_SubmitCompanyName", label: "Company Name" },
        { key: "DD_SubmitPersonName", label: "Person Name" },
        { key: "DD_SubmitMobileNo", label: "Mobile No." },
        { key: "DD_SubmitEmailId", label: "Email Id." },
        { key: "DD_ReturnCompanyName", label: "Company Name" },
        { key: "DD_ReturnPersonName", label: "Person Name" },
        { key: "DD_ReturnMobileNo", label: "Mobile No." },
        { key: "DD_ReturnEmailId", label: "Email Id." },
        { key: "FileName", label: "Documents" },
      ];

      // 🔴 Mandatory fields
      mandatoryFields.forEach((field) => {
        const value = vendor[field.key];
        const isEmpty = field.isDate
          ? !value
          : value === null ||
          value === undefined ||
          (typeof value === "string" && !value.trim());

        if (isEmpty) {
          errors[`${field.key}Err`] = `Please enter ${field.label}`;
          isValid = false;
        }
      });

      // 🔴 Sub-contractor empty row check
      if (
        vendor.subContractorList?.length > 0 &&
        vendor.subContractorList.some(
          (sub) =>
            !sub.PersonName?.trim() ||
            !sub.CompanyName?.trim() ||
            !sub.MobileNo?.trim() ||
            !sub.EmailId?.trim()
        )
      ) {
        isValid = false;
      }

      // 🔴 Duplicate sub-contractor check
      // if (
      //   vendor.subContractorList?.length > 0 &&
      //   this.checkDuplicates(vendor.subContractorList, [
      //     "PersonName",
      //     "CompanyName",
      //     "MobileNo",
      //     "EmailId",
      //   ])
      // ) {
      //   isValid = false;
      // }

      // 🔴 Email & mobile validation
      const validations = [
        ["DD_SubmitEmailId", emailValidator],
        ["DD_ReturnEmailId", emailValidator],
        ["DD_SubmitMobileNo", mobileNoValidator],
        ["DD_ReturnMobileNo", mobileNoValidator],
      ];

      validations.forEach(([key, validator]) => {
        const err = validator(vendor[key]?.trim() || "");
        if (err) {
          errors[`${key}Err`] = err;
          isValid = false;
        }
      });

      vendor.subContractorList?.forEach((sub) => {
        if (emailValidator(sub.EmailId?.trim())) isValid = false;
        if (mobileNoValidator(sub.MobileNo?.trim())) isValid = false;
      });

      if (!isValid) isAllValid = false;

      return isValid
        ? { ...vendor, isAddDD: true }
        : { ...vendor, ...errors };
    });

    this.setState({ DD_DetailsData: updatedList });
    return isAllValid;
  };

  render() {
    const {
      isLoading,
      exhCompanyName,
      hallNo,
      stallNo,
      companyName,
      personName,
      contactNo,
      email,
      isAgree,
      remark,
      personNameErr,
      companyNameErr,
      contactNoErr,
      emailErr,
      currentDate,
      DeadlineDate,
      DD_DetailsData,
      isImageModal,
      NonEmpanelVendorID,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      exitPersonNameErr,
      exitCompanyNameErr,
      exitContactNoErr,
      exitEmailErr,
      NonEmpanelVendorData,
      SameAsAbove,
      isHideSection,
      is_View,
      StatusID, isOpenConfirmationModal
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    console.log("xxxx", DeadlineDate, currentDate);
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          {!isHideSection && <ExhibitorTopMenu />}
          <div className="row">
            <div
              className="card-header py-2 border border-bottom-0 rounded-bottom-0"
              style={{ paddingLeft: "2rem" }}
            >
              <h3 className="card-title">Stall Possession</h3>
            </div>
          </div>
          {!isHideSection && (
            <div className="row  mt-4" style={{ paddingLeft: "1rem" }}>
              <h6 className="mt-2 ">
                Stall Possession{" "}
                <span className="text-danger">
                  {" "}
                  Last Date Of Submission -{" "}
                  {this.props.location?.state?.ActualDeadline
                    ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                    : "-"}
                </span>
              </h6>
            </div>
          )}
          
          <VendorDetails />
          <div>
            <div className="row g-2 mb-3 p-3">
              <div className="col-md-4">
                <label htmlFor="validationCustom03">Exhibitor Company Name</label>
                <input type="text" className="form-control" disabled value={exhCompanyName} />
              </div>
              <div className="col-md-4">
                <label htmlFor="validationCustom03">Hall No</label>
                <input type="text" className="form-control" disabled value={hallNo} />
              </div>
              <div className="col-md-4">
                <label htmlFor="validationCustom03">Stall No</label>
                <input type="text" className="form-control" disabled value={stallNo} />
              </div>
              {!isHideSection && (
                <div className="col-md-12 mt-4">
                  <h5 className="fw-semibold">
                    Please hand over possession of space allotted to us, to our representative
                    mentioned below:
                  </h5>
                </div>
              )}
              {!is_View && (
                <>
                  <div className="row g-2">
                    <div className="col-md-3">
                      <label htmlFor="validationCustom03">
                        Person Name <span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={personName}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          this.setState({ personName: e.target.value, personNameErr: "" })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {personNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom03">
                        Company Name <span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={companyName}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          this.setState({ companyName: e.target.value, companyNameErr: "" })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {companyNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom03">
                        Contact No <span className="text-red">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={contactNo}
                        // maxLength={countryId == 91 ? 10 : 20}
                        maxLength={10}
                        // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                        onInput={(e) => this.maxLengthCheck(e, 20)}
                        onKeyDown={(e) => this.preventMinus(e)}
                        onWheel={(e) => e.target.blur()}
                        onPaste={(e) => this.handlePaste(e)}
                        disabled={this.props.isModal || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          e.target.value >= 0 &&
                          this.setState({ contactNo: e.target.value, contactNoErr: "" })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {contactNoErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="validationCustom03">
                        Email ID <span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={email}
                        disabled={this.props.isModal || isDeadlinePassed || StatusID == 2}
                        onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {emailErr}
                        </span>
                      }
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <div className="shadow-none rounded-3 mb-3">
                      <div className="card-header py-2 border border-bottom-0 rounded-bottom-0">
                        Representative for Exit
                      </div>
                      <div class="card-body row pt-3 m-0 p-1 border">
                        {!is_View && (
                          <label className="d-flex align-items-center px-1">
                            <input
                              type="checkbox"
                              checked={SameAsAbove}
                              disabled={isDeadlinePassed || StatusID == 2}
                              onChange={(e) =>
                                this.setState({ SameAsAbove: e.target.checked }, () => {
                                  if (e.target.checked) {
                                    this.setState({
                                      exitPersonName: personName,
                                      exitCompanyName: companyName,
                                      exitContactNo: contactNo,
                                      exitEmail: email,
                                      exitPersonNameErr: "",
                                      exitCompanyNameErr: "",
                                      exitContactNoErr: "",
                                      exitEmailErr: "",
                                    });
                                  } else {
                                    this.setState({
                                      exitPersonName: "",
                                      exitCompanyName: "",
                                      exitContactNo: "",
                                      exitEmail: "",
                                      exitPersonNameErr: "",
                                      exitCompanyNameErr: "",
                                      exitContactNoErr: "",
                                      exitEmailErr: "",
                                    });
                                  }
                                })
                              }
                              className="mr-2 m-1 me-2"
                            />
                            Same as above
                          </label>
                        )}
                        <div class="row g-1">
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">
                              Person Name<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={exitPersonName}
                              maxLength={100}
                              disabled={isDeadlinePassed || StatusID == 2}
                              onChange={(e) =>
                                this.setState({
                                  exitPersonName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                                  exitPersonNameErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitPersonNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">
                              Company Name<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={exitCompanyName}
                              disabled={isDeadlinePassed || StatusID == 2}
                              maxLength={200}
                              onChange={(e) =>
                                this.setState({
                                  exitCompanyName: e.target.value,
                                  exitCompanyNameErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitCompanyNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">
                              Contact No<span className="text-red">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              value={exitContactNo}
                              disabled={isDeadlinePassed || StatusID == 2}
                              // maxLength={countryId == 91 ? 10 : 20}
                              maxLength={10}
                              // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                              onInput={(e) => this.maxLengthCheck(e, 20)}
                              onKeyDown={(e) => this.preventMinus(e)}
                              onWheel={(e) => e.target.blur()}
                              onPaste={(e) => this.handlePaste(e)}
                              onChange={(e) =>
                                this.setState({
                                  exitContactNo: e.target.value.replace(/\D/g, ""),
                                  exitContactNoErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitContactNoErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">
                              Email ID<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={exitEmail}
                              disabled={isDeadlinePassed || StatusID == 2}
                              maxLength={100}
                              onChange={(e) =>
                                this.setState({ exitEmail: e.target.value, exitEmailErr: "" })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitEmailErr}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {Object.keys(NonEmpanelVendorData).length != 0 && (
                    <div className="col-md-12 mt-3">
                      <div className="shadow-none rounded-3">
                        <div className="card-header py-2 border border-bottom-0 rounded-bottom-0">
                          Service Partner Details
                        </div>
                        <div class="card-body row g-2  m-0 p-0 border">
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">Person Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={NonEmpanelVendorData.PersonName}
                              maxLength={100}
                              disabled={true}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitPersonNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={NonEmpanelVendorData.CompanyName}
                              maxLength={200}
                              disabled={true}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitCompanyNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">Contact No</label>
                            <input
                              type="text"
                              className="form-control"
                              value={NonEmpanelVendorData.MobileNo}
                              // maxLength={countryId == 91 ? 10 : 20}
                              maxLength={100}
                              // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                              onInput={(e) => this.maxLengthCheck(e, 20)}
                              onKeyDown={(e) => this.preventMinus(e)}
                              onWheel={(e) => e.target.blur()}
                              onPaste={(e) => this.handlePaste(e)}
                              disabled={true}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitContactNoErr}
                              </span>
                            }
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="validationCustom03">Email ID</label>
                            <input
                              type="text"
                              className="form-control"
                              value={NonEmpanelVendorData.EmailId}
                              maxLength={100}
                              disabled={true}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {exitEmailErr}
                              </span>
                            }
                          </div>
                        </div>
                        {DD_DetailsData.length > 0 && (
                          <div className="card-body row g-2 m-0 p-0 border-0">
                            {DD_DetailsData.length > 0 ? (
                              DD_DetailsData.map((data, parentIndex) => (
                                <div className="border rounded mt-4">
                                  <h6 className="text-aqua mb-3">{data.ServiceName}</h6>
                                  <div className="row g-2 mb-3">
                                    <div className="col-md-3 mt-0">
                                      <label className="">
                                        DD Number<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        maxLength={100}
                                        value={data.DD_Number}
                                        disabled={isDeadlinePassed || StatusID == 2}
                                        className="form-control"
                                        onChange={(e) =>
                                          this.handleInput(e, "varchar", "DD_Number", parentIndex)
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_NumberErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3 mt-0">
                                      <label className="">
                                        DD Date<span className="text-red">*</span>
                                      </label>
                                      <DatePicker
                                        style={{ zIndex: "99999" }}
                                        selected={data.DD_Date ? new Date(data.DD_Date) : null}
                                        minDate={new Date()}
                                        disabled={isDeadlinePassed || StatusID == 2}
                                        dateFormat={"dd/MM/yyyy"}
                                        className="form-control"
                                        onChange={(e) =>
                                          this.handleInput(e, "date", "DD_Date", parentIndex)
                                        }
                                        peekNextMonth
                                        // minDate={fromDate}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText="To Date"
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_DateErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3 mt-0">
                                      <label className="">
                                        DD Amount<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        value={data.DD_Amount}
                                        maxLength={100}
                                        disabled={isDeadlinePassed}
                                        className="form-control"
                                        onChange={(e) =>
                                          this.handleInput(e, "int", "DD_Amount", parentIndex)
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_AmountErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3 mt-0">
                                      <label className="">
                                        Bank Name<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        value={data.DD_BankName}
                                        maxLength={200}
                                        disabled={isDeadlinePassed || StatusID == 2}
                                        className="form-control"
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_BankName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_BankNameErr}
                                        </span>
                                      }
                                    </div>
                                  </div>

                                  <div className="mt-3">
                                    {/* DD Submitted By */}
                                    <div className="card shadow-none border-0 mb-0">
                                      <div className="card-header py-2 border border-bottom-0 rounded-bottom-0">
                                        DD Submitted By
                                      </div>
                                      <div
                                        className="card-body row m-0 p-0 border pt-2"
                                        id="submittedSection"
                                      >
                                        <div className="rounded p-2 pt-0 mb-0">
                                          <div className="row g-2">
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Company Name<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={isDeadlinePassed || StatusID == 2}
                                                value={data.DD_SubmitCompanyName}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_SubmitCompanyName",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_SubmitCompanyNameErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Person Name<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={isDeadlinePassed || StatusID == 2}
                                                value={data.DD_SubmitPersonName}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_SubmitPersonName",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_SubmitPersonNameErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Email<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="email"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={isDeadlinePassed || StatusID == 2}
                                                value={data.DD_SubmitEmailId}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_SubmitEmailId",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_SubmitEmailIdErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Mobile No<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={10}
                                                disabled={isDeadlinePassed || StatusID == 2}
                                                value={data.DD_SubmitMobileNo}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "int",
                                                    "DD_SubmitMobileNo",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_SubmitMobileNoErr}
                                                </span>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* DD Returned By */}
                                    <div className="card shadow-none border-0 mb-1 mt-3">
                                      <div className="card-header py-2 border border-bottom-0 rounded-bottom-0">
                                        DD Return To
                                      </div>
                                      <div
                                        className="card-body row m-0 p-0 border"
                                        id="submittedSection"
                                      >
                                        <div className=" rounded p-2 mb-0">
                                          <div className="">
                                            <label className="d-flex align-items-center">
                                              <input
                                                type="checkbox"
                                                value={`SameAsAbove_${parentIndex}`}
                                                checked={data.SameAsAbove}
                                                disabled={isDeadlinePassed || StatusID == 2}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "checkbox",
                                                    "SameAsAbove",
                                                    parentIndex
                                                  )
                                                }
                                                className="mr-2 m-1 me-2"
                                              />
                                              Same as above
                                            </label>
                                          </div>
                                          <div className="row g-2 mt-0">
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Company Name<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={data.SameAsAbove || StatusID == 2}
                                                value={data.DD_ReturnCompanyName}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_ReturnCompanyName",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_ReturnCompanyNameErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Person Name<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={data.SameAsAbove || StatusID == 2}
                                                value={data.DD_ReturnPersonName}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_ReturnPersonName",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_ReturnPersonNameErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Email<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="email"
                                                className="form-control"
                                                maxLength={100}
                                                disabled={data.SameAsAbove || StatusID == 2}
                                                value={data.DD_ReturnEmailId}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "DD_ReturnEmailId",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_ReturnEmailIdErr}
                                                </span>
                                              }
                                            </div>
                                            <div className="col-md-3">
                                              <label className=" mb-1">
                                                Mobile No<span className="text-red">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={10}
                                                disabled={data.SameAsAbove || StatusID == 2}
                                                value={data.DD_ReturnMobileNo}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "int",
                                                    "DD_ReturnMobileNo",
                                                    parentIndex
                                                  )
                                                }
                                              />
                                              {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                  {data.DD_ReturnMobileNoErr}
                                                </span>
                                              }
                                            </div>

                                            <div class="card shadow-none border-0 mt-1 mb-0">
                                              <div class="text-dark py-2 fw-bold text-muted text-left">
                                                Photo ID{" "}
                                                <small>(Government Approved Document)</small>
                                              </div>
                                              <div class="card-body border rounded p-2">
                                                <div class="row g-2 align-items-center">
                                                  <div class="col-md-12">
                                                    <label class=" mb-1">
                                                      Capture / Upload Photo
                                                    </label>
                                                    {data.FileName != null &&
                                                      data.FilePath != null ? (
                                                      <>
                                                        {data.FileName != null &&
                                                          data.FileType != null ? (
                                                          <div
                                                            className="d-flex"
                                                            style={{ justifyContent: "left" }}
                                                          >
                                                            <div className="chooseStallFile m-0">
                                                              <p
                                                                className="overflow-membership m-0"
                                                                onClick={() =>
                                                                  this.handleViewFile(
                                                                    data.FilePath
                                                                  )
                                                                }
                                                                style={{ cursor: "pointer" }}
                                                              >
                                                                {data.FileName}
                                                              </p>
                                                              {!isDeadlinePassed && (
                                                                <span
                                                                  className="membership_file_cross text-danger"
                                                                  onClick={() =>
                                                                    this.handleRemoveFile(
                                                                      parentIndex
                                                                    )
                                                                  }
                                                                >
                                                                  X
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <div
                                                            className="d-flex"
                                                            style={{ justifyContent: "left" }}
                                                          >
                                                            <div className="chooseStallFile m-0">
                                                              <a
                                                                className="overflow-membership m-0"
                                                                target="_blank"
                                                                href={
                                                                  BASE_URL.split("/api")[0] +
                                                                  data.FilePath
                                                                }
                                                                style={{ cursor: "pointer" }}
                                                              >
                                                                {data.FileName}
                                                              </a>
                                                              {!isDeadlinePassed && (
                                                                <span
                                                                  className="membership_file_cross text-danger"
                                                                  onClick={() =>
                                                                    this.handleRemoveFile(
                                                                      parentIndex
                                                                    )
                                                                  }
                                                                >
                                                                  X
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <div class="d-block d-md-flex align-items-md-center">
                                                        <button
                                                          class="btn btn-aqua mb-2 mb-md-0"
                                                          disabled={
                                                            isDeadlinePassed || StatusID == 2
                                                          }
                                                          onClick={() =>
                                                            this.handleOpenModal(parentIndex)
                                                          }
                                                        >
                                                          <i class="bi bi-camera"></i> Open Camera
                                                        </button>
                                                        <span class="mx-2 text-muted">or</span>
                                                        <span></span>
                                                        <input
                                                          type="file"
                                                          class="form-control w-auto"
                                                          id="inputGroupFile"
                                                          disabled={
                                                            isDeadlinePassed || StatusID == 2
                                                          }
                                                          onChange={(e) =>
                                                            this.handleInput(
                                                              e,
                                                              "file",
                                                              "Document",
                                                              parentIndex
                                                            )
                                                          }
                                                          accept={".jpg,.jpeg,.png,.pdf"}
                                                        />
                                                        &nbsp;
                                                        <span
                                                          className="text-aqua"
                                                          style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            display: "block",
                                                          }}
                                                        >
                                                          Max 5MB | Pdf, Jpeg, Jpg, Png only
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {data.FileNameErr}
                                                    </span>
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Add Subcontractor Button */}
                                  <div className="mb-2 mt-3 text-left">
                                    <button
                                      type="button"
                                      className="btn btn-aqua p-1"
                                      onClick={() => {
                                        const updatedList = [...this.state.DD_DetailsData];
                                        updatedList[parentIndex].subContractorList.push({
                                          CompanyName: "",
                                          PersonName: "",
                                          EmailId: "",
                                          MobileNo: "",
                                        });
                                        this.setState({ DD_DetailsData: updatedList });
                                      }}
                                    >
                                      <i className="ri-add-line me-1" /> Add Subcontractor
                                    </button>
                                  </div>

                                  {/* Subcontractor Table */}
                                  <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                      <thead className="table-light">
                                        <tr>
                                          <th>Company Name</th>
                                          <th>Person Name</th>
                                          <th>Email</th>
                                          <th>Mobile No</th>
                                          <th className="text-center">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {data.subContractorList.length > 0 ? (
                                          data.subContractorList.map((item, childIndex) => (
                                            <tr key={childIndex}>
                                              <td>
                                                <input
                                                  type="text"
                                                  value={item.CompanyName}
                                                  maxLength={100}
                                                  disabled={isDeadlinePassed || StatusID == 2}
                                                  className="form-control"
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "varchar",
                                                      "CompanyName",
                                                      parentIndex,
                                                      childIndex
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  value={item.PersonName}
                                                  maxLength={100}
                                                  disabled={isDeadlinePassed || StatusID == 2}
                                                  className="form-control"
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "varchar",
                                                      "PersonName",
                                                      parentIndex,
                                                      childIndex
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  value={item.EmailId}
                                                  maxLength={100}
                                                  disabled={isDeadlinePassed || StatusID == 2}
                                                  className="form-control"
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "varchar",
                                                      "EmailId",
                                                      parentIndex,
                                                      childIndex
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  value={item.MobileNo}
                                                  maxLength={10}
                                                  className="form-control"
                                                  disabled={isDeadlinePassed || StatusID == 2}
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "int",
                                                      "MobileNo",
                                                      parentIndex,
                                                      childIndex
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td className="text-center">
                                                {!isDeadlinePassed ? (
                                                  <i
                                                    className="fa fa-trash text-danger"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                      this.handleDelete(parentIndex, childIndex)
                                                    }
                                                  />
                                                ) : (
                                                  "-"
                                                )}
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={5} className="text-center">
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center">Record not found</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
              {!isHideSection && (
                <label className="my-2">
                  {" "}
                  <input
                    type="checkbox"
                    value={isAgree}
                    checked={isAgree}
                    disabled={isDeadlinePassed || StatusID == 2}
                    onChange={(e) => this.setState({ isAgree: !isAgree })}
                  />{" "}
                  We agree that we have paid all the dues as per the payment schedule and other
                  charges for utilities given in the online manual.
                </label>
              )}

              <div className="col-md-12">
                <label>Remark</label>
                <textarea
                  className="form-control"
                  rows={3}
                  value={remark}
                  disabled={is_View || isDeadlinePassed || StatusID == 2}
                  onChange={(e) => this.setState({ remark: e.target.value })}
                />
              </div>

              <div className="row m-0">
                <fieldset className="d-flex justify-content-end mt-3 mb-4">
                  {!isHideSection && (
                    <>
                      <button
                        className="btn btn-aqua"
                        style={{ padding: "3px 7px", marginRight: 10 }}
                        disabled={isDeadlinePassed || StatusID == 2}
                        // onClick={(e) => this.onSubmit()}
                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                      >
                        {this.state.StatusID == 0 ? "Submit" : "Update"}
                      </button>

                      <button
                        className="btn btn-gray py-1"
                        style={{ padding: "3px 7px" }}
                        onClick={(e) => this.onCancelClick(e)}
                      >
                        Back
                      </button>
                    </>
                  )}
                </fieldset>
              </div>
              <div className="row">
                {isDeadlinePassed && (
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                )}
              </div>
            </div>
          </div>
        </div>

        <ImageCapture
          isOpen={isImageModal}
          onClose={this.handleCloseModal}
          onCapture={this.handleCapture}
        />
      </>
    );
  }
}
export default withRouter(
  connect(null, { getStallPossession_action, insertStallPossession_action })(StallPossesion)
);
